import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { StringKeyDictionary } from "../../commonInterfaces";
import { Grid } from "../../core/components/grid";
import { ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { EditSkillResult, openEditSkill } from "./editSkill";
import { Skill } from "./skillsInterfaces";
import React from "react";
export class SkillGrid extends React.Component<any, SkillGridState>{
    private translations: StringKeyDictionary<string>;
    private gridOptions: kendo.ui.GridOptions;

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            fid: null,
            type: 0,
            usePriority: this.props.entity.SkillsSettings.UsePrioritySkills
        }
        this.initApp()
    }

    private initApp = async () => {
        let result = await Helper.getTranslations([
            "WebCRM.EditIndividualFields.Designations",
            "WebSMS.GeneralSettings.UebersetzungenBearbeiten",
            "Skills.SelectCategory",
            "Skills.NameOfNewSkill",
            "Standard.Priority"
        ]);
        this.translations = result.Data;

        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (data: { cmd: string, id: number, type: number }) => {
            if (data.cmd == "skillCategorySelectionChange") {
                this.setState({ fid: data.id, type: data.type }, this.reloadData);
            } else if (data.cmd == "skillCategoryDeleted") {
                this.setState({ data: [], fid: null })
            }
        });
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Rtext",
                    title: Helper.getTranslation("WebCRM.EditIndividualFields.Designations")
                },
                {
                    field: "Prio",
                    title: Helper.getTranslation("Standard.Priority"),
                    hidden: !this.state.usePriority
                },
                {
                    field: "Order",
                    title: Helper.getTranslation("Skills.Order"),
                    hidden: !this.state.usePriority
                }
            ]
        };
        this.setState({})
    }

    private reloadData = async () => {
        let id = this.state.fid;
        let result = await HTTPService.get<JsonResultClass<Skill[]>>(`EditSkill/GetAllSkills?id=${id}`)
        if (result.Code == 0) {
            this.setState({ data: result.Data });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private createReplacementText = () => {
        return (
            <div style={{ display: "grid" }}>
                <div style={{ display: "flex", justifyContent: "center", gridArea: "1/1/1/1" }}>
                    <i className={"fal fa-ban fa-10x"} style={{ opacity: 0.1 }}></i>
                </div>
                <div style={{ textAlign: "center", gridArea: "1/1/1/1", paddingTop: "40px" }}>
                    <label style={{ fontSize: "15px" }}>
                        {this.translations["Skills.SelectCategory"]}
                    </label>
                </div>
            </div>
        );
    }

    private createGrid = () => {
        const buttons = [
            {
                caption: Config.translations.newLabel,
                type: ToolBarStandardButtonType.NEW,
                enabled: Helper.hasValue(this.state.fid)
            },
            {
                caption: Config.translations.editLabel,
                type: ToolBarStandardButtonType.EDIT,
                enabled: true
            },
            {
                caption: Config.translations.deleteLabel,
                type: ToolBarStandardButtonType.DELETE,
                enabled: true
            }
        ]
        return (
            <div className="flex-container" style={{ height: "350px" }}>
                <Grid
                    data={this.state.data}
                    options={this.gridOptions}
                    id="generalSettings_SkillsGrid"
                    standardButtons={buttons}
                    onClickStandardButton={this.onButtonClick}
                />
            </div>
        );
    }

    private onButtonClick = (type: ToolBarStandardButtonType, dataItem: Skill) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                this.addNewSkill()
                break;
            case ToolBarStandardButtonType.DELETE:
                this.deleteSkill(dataItem);
                break;
            case ToolBarStandardButtonType.EDIT:
                this.editSkill(dataItem);
                break;
        }
    }

    private addNewSkill = async () => {
        let editSkillResult = await openEditSkill(null, this.state.usePriority);
        editSkillResult.skill.Fid = this.state.fid;
        this.saveSkill(editSkillResult);
    }

    private editSkill = async (dataItem: Skill) => {
        let editSkillResult = await openEditSkill(dataItem, this.state.usePriority);
        this.saveSkill(editSkillResult);
    }

    private saveSkill = async (editSkillResult: EditSkillResult) => {
        let result = await HTTPService.post<JsonResultClass<Skill>>("EditSkill/SaveSkill", editSkillResult);
        if (result.Code == 0) {
            this.reloadData();
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private deleteSkill = async (dataItem: Skill) => {
        let isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            let result = await HTTPService.post<JsonResultClass>(`Skills/DeleteSkill`, dataItem)
            if (result.Code == 0) {
                this.reloadData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    render() {
        let body = <></>;

        if (Helper.hasValue(this.state.fid) && this.state.type != -1) {
            body = Helper.hasValue(this.gridOptions) ? this.createGrid() : null;
        } else {
            body = Helper.hasValue(this.translations) ? this.createReplacementText() : null;
        }
        return <>{body}</>
    }
}

export interface SkillGridState {
    data: Skill[];
    fid: number;
    type: number;
    usePriority: boolean;
}